module.exports = __webpack_public_path__ + "static/media/ins-2.5903f329.jpg";